module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-select",
    attrs: {
      "id": 'multiselect-' + _vm.uniq
    }
  }, [_c('button', {
    ref: "button",
    staticClass: "nice-select",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleMenu()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.visibleValue)), _c('span', [_vm._v("▾")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a0772f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/SingleSelect.vue
// module id = 413
// module chunks = 1